import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Seniors from "@/pages/Seniors";
import ShopDeck from "@/pages/ShopDeck";
import Collections from "@/pages/Collections";
import CollectionDetail from "@/pages/CollectionDetail";
import Organizations from "@/pages/Organizations";
import Faq from "@/pages/Faq";
import Contact from "@/pages/Contact";
import Policy from "@/pages/Policy";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import TryFree from "@/pages/TryFree";
import Trial from "@/pages/Trial";
import Admin from "@/pages/Admin";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App min-h-screen bg-cream text-ink font-body">
      <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/seniors" element={<Seniors />} />
            <Route path="/shop/seniors-deck" element={<ShopDeck />} />
            <Route path="/collections" element={<Collections />} />
            <Route path="/collections/:collectionId" element={<CollectionDetail />} />
            <Route path="/organizations" element={<Organizations />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/policies/:policyKey" element={<Policy />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/try-free" element={<TryFree />} />
            <Route path="/trial/:token" element={<Trial />} />
            <Route path="/admin" element={<Admin />} />
          </Route>
        </Routes>
      </BrowserRouter>
      </HelmetProvider>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
